import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useWidgetConfig } from '../../providers/WidgetProvider/WidgetProvider.js';
import { getWidgetMaxHeight } from '../../utils/widgetSize.js';
import { ExpansionTransition } from '../Expansion/ExpansionTransition.js';
import { chainExpansionWidth, SelectChainExpansionContainer, } from './ChainsExpanded.style.js';
import { SelectChainContent } from './SelectChainContent.js';
export const ChainsExpanded = memo(function ChainsExpanded({ formType, open, }) {
    const { theme } = useWidgetConfig();
    return (_jsx(ExpansionTransition, { in: open, width: chainExpansionWidth, children: _jsx(SelectChainExpansionContainer, { expansionHeight: getWidgetMaxHeight(theme), children: _jsx(SelectChainContent, { inExpansion: true, formType: formType }) }) }));
});
//# sourceMappingURL=ChainsExpanded.js.map